import Slide from "../../../../../../components/Slide";
import { Box, Grid, makeStyles } from "@material-ui/core";
import { theme } from "../../../../../../theme";

import ZitatImage from "../../../../../../assets/_Chapters/Karriere/Zitate/berufserfahrene-1.webp";

const useStyles = makeStyles((theme) => ({
  fontRegular: {
    marginTop: "5px",
    fontWeight: 400,
  },
  heightCorrection: {
    display: "flex",
    justifyContent: "center",
    height: "calc(100dvh - 90px * 2)",
  },
}));
export default function Zitat1() {
  const classes = useStyles();
  return (
    <Slide background={{ width: "100dvw", color: theme.palette.primary.main }}>
      <Grid container alignItems="center" spacing={5}>
        <Grid item xs={12}>
          <Box className={classes.heightCorrection}>
            <svg
              style={{ width: "100%", height: "100%" }}
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              width="1932"
              height="990"
              viewBox="0 0 1932 990"
              fill="none"
            >
              <g clip-path="url(#clip0_897_87)">
                <text
                  fill="white"
                  xmlSpace="preserve"
                  style="white-space: pre"
                  font-family="Interstate"
                  font-size="30"
                  letter-spacing="0em"
                >
                  <tspan x="1231" y="982.8">
                    Jasmin, seit 2024 im Marketing
                  </tspan>
                </text>
                <mask
                  id="mask0_897_87"
                  style="mask-type:alpha"
                  maskUnits="userSpaceOnUse"
                  x="1231"
                  y="0"
                  width="701"
                  height="937"
                >
                  <rect x="1231" width="701" height="937" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_897_87)">
                  <rect
                    x="1234"
                    y="-92"
                    width="698"
                    height="1047"
                    fill="url(#pattern0_897_87)"
                  />
                </g>
                <text
                  fill="white"
                  xmlSpace="preserve"
                  style="white-space: pre"
                  font-family="Interstate"
                  font-size="120"
                  font-weight="bold"
                  letter-spacing="0em"
                >
                  <tspan x="0" y="361.2">
                    „Die lehrreiche Einar-
                  </tspan>
                  <tspan x="0" y="505.2">
                    beitungsphase gab mir
                  </tspan>
                  <tspan x="0" y="649.2">
                    ein sicheres Gefühl für
                  </tspan>
                  <tspan x="0" y="793.2">
                    das Arbeiten hier.“
                  </tspan>
                </text>
              </g>
              <defs>
                <pattern
                  id="pattern0_897_87"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use
                    xlinkHref="#image0_897_87"
                    transform="scale(0.000366211 0.000244141)"
                  />
                </pattern>
                <clipPath id="clip0_897_87">
                  <rect width="1932" height="990" fill="white" />
                </clipPath>
                <image
                  id="image0_897_87"
                  width="2731"
                  height="4096"
                  xlinkHref={ZitatImage}
                />
              </defs>
            </svg>
          </Box>
        </Grid>
      </Grid>
    </Slide>
  );
}
